import script from "./Info.vue?vue&type=script&setup=true&lang=ts"
export * from "./Info.vue?vue&type=script&setup=true&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=23d59993&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d59993"]])

export default __exports__